import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Icon, NamedLink } from '../../components';

import actionFirstImage from './img/action1-img.svg';
import actionSecondImage from './img/action2-img.svg';

import css from './CreatorsPage.module.css';

const SectionAction = () => {
  return (
    <div className={css.sectionAction}>
      <h2 className={css.actionTitle}>
        <FormattedMessage id="CreatorsPage.actionTitle" />
      </h2>
      <div className={css.actionContent}>
        <NamedLink
          className={css.actionLink}
          name="TopicPage"
          params={{
            topicId: 'becoming-a-creator',
          }}
        >
          <img
            className={css.actionImage}
            loading="lazy"
            src={actionFirstImage}
            alt="Start involving"
          />
          <div className={css.actionImageText}>
            <h3 className={css.actionImageTitle}>
              <FormattedMessage id="CreatorsPage.actionImageText" />
            </h3>
            <Icon name="arrowRight" size={24} className={css.actionImageArrow} />
          </div>
        </NamedLink>
        <NamedLink className={css.actionLink} name="RoleSelectionPage">
          <img
            className={css.actionImage}
            loading="lazy"
            src={actionSecondImage}
            alt="Start attracting"
          />
          <div className={css.actionImageText}>
            <h3 className={css.actionImageTitle}>
              <FormattedMessage id="CreatorsPage.actionImageSecondText" />
            </h3>
            <Icon name="arrowRight" size={24} className={css.actionImageArrow} />
          </div>
        </NamedLink>
      </div>
    </div>
  );
};

export default SectionAction;
